import React, { useEffect, useState } from 'react';
import apiSafibc from '../../axios/axios';
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../toastify/config";
import Swal from 'sweetalert2'
import { useLoginStore } from '../../store/zustend';
import EditIcon from '@mui/icons-material/Edit';
import ModalEditAhorrador from './ModalEditAhorrador';
import { Autocomplete, Box, Button, FormControl, IconButton, InputLabel, MenuItem, Modal, Paper, Select, TextField } from '@mui/material';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';


const styleCi = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '5px',
    width: '50%'
};

const Ahorradores = () => {


    const [ahorradores, setAhorradores] = useState([])
    const [editAhorrador, setEditAhorrador] = useState()
    const [ahorradorselect, setAhorradorselect] = useState()
    const [openModal, setOpenModal] = useState()
    const [openAsignar, setOpenAsignar] = useState(false)
    const [usuarios, setUsuarios] = useState([])
    const [usuarioAsignar, setUsuarioAsignar] = useState('')
    const [spAUA, setSpAUA] = useState(false)
    const [ahorradorSelectId, setAhorradorSelectId] = useState('')


    const { loginStore } = useLoginStore()


    const consultarAhorradores = () => {

        const ahorradores = async () => {
            try {
                const cargarAhorradores = await apiSafibc('/ahorradores/obtener-ahorradores', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setAhorradores(cargarAhorradores.data)


            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        ahorradores()

    }



    const consultarAhorrador = (ahorradorId) => {

        const buscahorrador = async (ida) => {
            try {

                const ia = btoa(ida)

                const cargarAhorrador = await apiSafibc(`/ahorradores/info-ahorrador/${ia}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })
                console.log(cargarAhorrador.data)
                setAhorradorselect(cargarAhorrador.data)
                setAhorradorSelectId(ahorradorId)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar catalogos, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }
        }

        buscahorrador(ahorradorId)
    }

    useEffect(() => {
        consultarAhorradores()
    }, [])

    const handleChange = (e, id) => {
        e.preventDefault()

        consultarAhorrador(id)
    }

    const cerrarModal = () => {
        setOpenModal(false);
        //setAhorradorselect(null);
    };

    const asignarModal = () => {

        const buscarUsuarios = async () => {

            try {

                const buscar = await apiSafibc.get('/ahorradores/usuarios', {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setUsuarioAsignar('')
                setUsuarios(buscar.data)
                setOpenAsignar(true)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar usuarios, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
            }

        }

        buscarUsuarios()

    }


    const asignarUsuarioAhorrador = () => {

        const asignar = async () => {

            try {

                setSpAUA(true)

                const jAsignar = {
                    id_usuario: usuarioAsignar,
                    id_ahorrador: ahorradorSelectId 
                }

                const asignando = await apiSafibc.post('/ahorradores/asignar-usuario', jAsignar,{
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`,
                        'Accept': 'application/x-www-form-urlencoded',
                        'Content-Type': 'application/x-www-form-urlencoded',
                    }
                })

                setOpenAsignar(false)

                Swal.fire({
                    icon: 'success',
                    title: 'Enhorabuena!',
                    text: asignando.data.mensaje
                }).then((result) => {
                    window.location.href = '/ahorradores'
                })


                 setSpAUA(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.mensaje) {
                        msg_error = error.response.data.mensaje
                    } else {
                        msg_error = 'Ocurrió un error al buscar usuarios, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setSpAUA(false)
            }

        }

        asignar()

    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">

                    <div className="card shadow">
                        <div className="card-body">
                            <div className="row">
                                <div className='col-md-6 mb-5'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>

                                        <Autocomplete
                                            disablePortal
                                            options={ahorradores.map((ahorrador) => ({ id: ahorrador.id_ahorrador, label: `${ahorrador.nombre} ${ahorrador.paterno} ${ahorrador.materno}` }))}
                                            onChange={(event, ahorrador) => {
                                                if (!ahorrador) return
                                                handleChange(event, ahorrador.id)
                                            }}
                                            renderInput={(params) => <TextField {...params} label="Ahorrador" variant='standard' />}
                                        />


                                    </FormControl>
                                </div>

                            </div>

                            <div className='table-responsive'>

                                <table className="table">
                                    <thead className='text-center'>
                                        <tr>
                                            <th>Nombre</th>
                                            <th>Apellido Paterno</th>
                                            <th>Apellido Materno</th>
                                            <th>Correo</th>
                                            <th>Celular</th>
                                            <th>RFC</th>
                                            <th>HOMOCLAVE</th>
                                            <th>Fecha Nacimiento</th>
                                            <th>Asignar</th>
                                            <th>Usuario Asignado</th>
                                            <th>Editar</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-center'>
                                        {ahorradorselect &&
                                            <tr className='animation' key={ahorradorselect.id_ahorrador}>
                                                <td>{ahorradorselect.nombre}</td>
                                                <td>{ahorradorselect.paterno}</td>
                                                <td>{ahorradorselect.materno}</td>
                                                <td>{ahorradorselect.correo}</td>
                                                <td>{ahorradorselect.cel}</td>
                                                <td>{ahorradorselect.rfc}</td>
                                                <td>{ahorradorselect.homoclave}</td>
                                                <td>{ahorradorselect.fecha_nacimiento}</td>
                                                <td>
                                                    <IconButton aria-label="asignar" onClick={asignarModal}>
                                                        <AssignmentIndIcon />
                                                    </IconButton>

                                                </td>
                                                <td>{ahorradorselect.usuario_pertenece_nombre ? ahorradorselect.usuario_pertenece_nombre : 'SIN ASIGNAR'}</td>
                                                <td>
                                                    <Button variant='contained' onClick={(e) => setOpenModal(true)}>
                                                        <EditIcon />
                                                    </Button>
                                                </td>
                                            </tr>

                                        }
                                    </tbody>

                                </table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                transition={Flip}
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />

            {openModal && (
                <ModalEditAhorrador
                    open={openModal}
                    onClose={cerrarModal}
                    ahorrador={ahorradorselect}

                />

            )}

            <Modal
                open={openAsignar} onClose={() => setOpenAsignar(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleCi}>
                    <div className='nav-header2 pt-4'></div>
                    <div className='card'>
                        <div className='card-header text-center'>
                            <h3>Asignar Usuario</h3>
                        </div>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-md-12 mb-3'>
                                    <FormControl variant="standard" sx={{ minWidth: '100%' }}>
                                        <InputLabel id="demo-simple-select-standard-label">Usuario Asignar</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={usuarioAsignar}
                                            onChange={(e) => setUsuarioAsignar(e.target.value)}
                                            label="Usuario Pertenece"
                                        >
                                            {usuarios && usuarios.map(usr => (
                                                <MenuItem value={usr.id_usuario} key={usr.id_usuario}>{usr.nombre_usuario}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className='col-md-12 mb-3'>
                                    <Button disabled={spAUA} variant='contained' onClick={asignarUsuarioAhorrador}>Asignar</Button>
                                    {spAUA && <div className="spinner-border spinner-border-sm" role="status" id='spisLoad'>
                                        <span className="sr-only"></span>
                                    </div>}
                                </div>
                            </div>

                        </div>
                    </div>
                </Box>

            </Modal>



        </div>
    )
}

export default Ahorradores